import React, { useState } from "react";
import OtpInput from "react-otp-input";
import Banner from "./banner";
import "./style.css";
import { useSubmitForgotOTPMutation , useSubmitForgotPasswordMutation} from "../../../services/RegisterAPI";
import { useLocation , useNavigate } from "react-router-dom";
import { useGetColorThemeQuery } from "../../../services/commonAPI";

const OTPField = () => {
    const [otp, setOtp] = useState("");
    const [submitOTP, { isLoading }] = useSubmitForgotOTPMutation();
    const location = useLocation();
    const responseEmail = location.state?.email || "";
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const navigate = useNavigate();
    const handleChange = (value) => {
        setOtp(value);
    };
 const [submitForgotOtp, { isLoading:submitotp }] = useSubmitForgotPasswordMutation();
    const {
        data: colorthemeData,
    } = useGetColorThemeQuery();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage(null);
        if (otp.length !== 6) {
            alert("Please enter a valid 6-digit OTP.");
            return;
        }

        try {
            const formData = {
                email:responseEmail,
                otp:otp
            }
            const response = await submitOTP( formData ).unwrap(); 
            const emailResponse = response.email;
            const responseotp= response.otp;
            setMessageType("success");
           setMessage(response.message);
           setTimeout(() => {
            navigate("/reset-password", { state: { email: emailResponse,otp:responseotp } });
        }, 3000);
        } catch (error) {
            setMessage(error.data?.message || error.data?.error || "Failed to send OTP");
            setMessageType("error");
        }
    };

    const handleResendOtp = async (e)=>{
        e.preventDefault();
        setMessage(null);
        try {

            const formData = {
                email:responseEmail,
            }
            const response = await submitForgotOtp(formData).unwrap();
            setMessage(response.message);
            if (response.success === true) {
                setMessageType("success");
                console.log("response")
                const responseEmail = response?.email
                setTimeout(() => {
                    navigate("/forgot-otp", { state: { email: responseEmail } });
                }, 3000);
            } else {
                setMessageType("error");
            }
        } catch (error) {
            setMessage(error.data?.message || error.data?.error || "Failed to Login.");
            setMessageType("error");
        }
    }

    return (
        <>
            <Banner />
            <section className="forgot-otp-input">
                <div className="container">
                    <div className="row justify-center">
                        <div className="col-md-6 col-sm-12 col-lg-6">
                        <h4 className="mb-4">Enter OTP</h4>
                            <form onSubmit={handleSubmit}>
                                <OtpInput
                                    value={otp}
                                    onChange={handleChange}
                                    numInputs={6}
                                    renderInput={(props) => <input {...props} />}
                                    inputStyle={{
                                        width: "40px",
                                        height: "40px",
                                        margin: "5px",
                                        fontSize: "20px",
                                        textAlign: "center",
                                        border: "1px solid #ccc",
                                        borderRadius: "5px",
                                    }}
                                />
                                <button
                                    type="submit"
                                    className="primary-button mt-3"
                                    disabled={isLoading}
                                        style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}
                                >
                                    {isLoading ? "Verifying..." : "Submit OTP"}
                                </button>
                                <p className="text-center resend-otp-text">Don't receive the code? <span style={{ color: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }} onClick={handleResendOtp}>{submitotp?"Submitting..." : "Resend"}</span></p>
                            </form>
                            {message && (
                                    <p
                                        className={
                                            messageType === "success"
                                                ? "success-message"
                                                : "error-message"
                                        }
                                    >
                                        {message}
                                    </p>
                                )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default OTPField;
